import { z } from 'zod';
import { apiEnvelope } from '../envelope';

/** ADR-002 response envelope for GET /api/v1/greeting. */
export const greetingResponseSchema = apiEnvelope(z.string());
